import React from 'react';
import { useLocaleContext } from '../../../../../context/LocaleContext';
import { unixFormat } from '../../../../../helpers/times';
import { replaceHost } from '../../../../../helpers/replace-host';
import { FORMAT_FULLPAGE } from '../../../../../../../cp/components/EventPage/SchedulePdfConstructorPage/constants';

import './style.scss';

const ViewWrapper = ({scheduleDate, count, pdfSettings, children}) => {
    const $locale = useLocaleContext();

    const contentVisibility = React.useMemo(() => {
        return pdfSettings.format !== FORMAT_FULLPAGE || (pdfSettings.format === FORMAT_FULLPAGE && count < 2)
            ? 'block'
            : 'none';
    }, [pdfSettings.format, count]);

    return (
        <div className={`pdf-schedule pdf-schedule-${pdfSettings.view}`}>
            {
                pdfSettings.headerImage &&
                <div
                    className="pdf-schedule-banner"
                    style={{
                        display: contentVisibility,
                    }}
                >
                    <img src={replaceHost(pdfSettings.headerImage)} alt="" />
                </div>
            }
            {
                pdfSettings.showTitle &&
                <div
                    className="pdf-schedule-title"
                    style={{
                        display: contentVisibility,
                        fontSize: pdfSettings.titleSize,
                    }}
                >
                    {$locale.getProperty(pdfSettings, 'title')}
                </div>
            }
            {
                pdfSettings.showDate &&
                <div
                    className="pdf-schedule-date"
                    style={{
                        color: pdfSettings.dateColor ? `#${pdfSettings?.dateColor}` : '',
                    }}
                >
                    {unixFormat(scheduleDate, 'DD MMMM')}
                </div>
            }
            <div className="pdf-schedule-container">
                {children}
            </div>
        </div>
    )
};

export default ViewWrapper;
